import React, { useState } from 'react';
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL
} from "firebase/storage";
import {
  getFirestore,
  collection,
  doc,
  setDoc,
  serverTimestamp,
  query,
  orderBy,
  limit,
  getDocs
} from "firebase/firestore";
import app from './firebase';

function UploadWallpaper({ onUploadSuccess }) {
  const [files, setFiles] = useState([]);
  const [uploadStatuses, setUploadStatuses] = useState({});

  const handleChange = (e) => {
    setFiles(Array.from(e.target.files));
    setUploadStatuses({});
  };

  const handleUpload = async () => {
    if (files.length === 0) {
      alert('Please select at least one file.');
      return;
    }

    const storage = getStorage(app);
    const db = getFirestore(app);

    // 🔹 Uzmi najveći trenutni "order"
    let maxOrder = 0;
    try {
      const q = query(collection(db, "wallpapers"), orderBy("order", "desc"), limit(1));
      const snapshot = await getDocs(q);
      if (!snapshot.empty) {
        maxOrder = snapshot.docs[0].data().order || 0;
      }
    } catch (e) {
      console.warn("⚠️ Greška pri čitanju max order vrednosti:", e.message);
    }

    let currentOrder = maxOrder + 1;

    for (const file of files) {
      const storageRef = ref(storage, `wallpapers/${file.name}`);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        'state_changed',
        (snapshot) => {
          const prog = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
          setUploadStatuses(prev => ({
            ...prev,
            [file.name]: { ...(prev[file.name] || {}), progress: prog }
          }));
        },
        (error) => {
          setUploadStatuses(prev => ({
            ...prev,
            [file.name]: { ...(prev[file.name] || {}), message: "Upload error: " + error.message }
          }));
        },
        async () => {
          try {
            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);

            // 🔹 Ukloni ekstenziju iz imena fajla za ID
            const cleanName = file.name.replace(/\.[^/.]+$/, "");

            // 🔹 Kreiraj dokument sa tim ID-jem
            const docRef = doc(db, "wallpapers", cleanName);
            await setDoc(docRef, {
              name: file.name,
              url: downloadURL,
              createdAt: serverTimestamp(),
              tags: [],
              categories: [],
              albums: [],
              downloads: 0,
              likes: 0,
              status: "draft",
              order: currentOrder
            });

            console.log(`✅ Uploadovan ${file.name} (ID: ${cleanName}) sa order=${currentOrder}`);
            currentOrder++;

            setUploadStatuses(prev => ({
              ...prev,
              [file.name]: { ...(prev[file.name] || {}), message: "Upload successful!" }
            }));

            if (onUploadSuccess) {
              onUploadSuccess();
            }
          } catch (e) {
            setUploadStatuses(prev => ({
              ...prev,
              [file.name]: { ...(prev[file.name] || {}), message: "Firestore error: " + e.message }
            }));
          }
        }
      );
    }

    setFiles([]);
  };

  return (
    <div style={{ margin: 30 }}>
      <h2>Upload Wallpapers (multiple files)</h2>
      <input type="file" multiple onChange={handleChange} />
      <button onClick={handleUpload} style={{ marginLeft: 10 }}>Upload All</button>
      <div style={{ marginTop: 20 }}>
        {files.length > 0 && <p>Selected files: {files.map(f => f.name).join(', ')}</p>}
        {Object.entries(uploadStatuses).map(([fileName, status]) => (
          <div key={fileName}>
            <strong>{fileName}:</strong> {status.progress ? `Progress: ${status.progress}%` : ''} {status.message || ''}
          </div>
        ))}
      </div>
    </div>
  );
}

export default UploadWallpaper;
